module.exports = __webpack_public_path__ + "img/四川天府一幼.56ba8eea.jpg";